(() => {
  const burger = document.getElementById('burger');
  const sheet = document.getElementById('menuSheet');
  if (!burger || !sheet) return;

  const setOpen = (open) => {
    burger.classList.toggle('open', open);
    sheet.classList.toggle('open', open);
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('lume-menu-open', open);
  };

  burger.addEventListener('click', () => setOpen(!sheet.classList.contains('open')));
  sheet.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setOpen(false);
  });
})();
